import React from 'react'
import SparxLogo from '../SparxLogo'
// Icons
import { ReactComponent as Error } from './icons/error.svg'

function ConfigurationInvalidSplash(props) {
  return (
    <div className="h-[100dvh] w-[100dvw] flex items-center flex-col justify-center bg-white">
      <div className="h-[128px]">
        <Error />
      </div>

      <div className="text-md lg:text-xl mt-[20px] text-center px-[32px] lg:px-0">
        SparX cannot load the page without a proper setup
      </div>
      <div className="text-xs mt-[10px] text-center px-[32px] lg:px-0 opacity-50">
        Please ensure that all application parameters are correctly set and match valid values.
      </div>
      <div className="mt-[32px]">
        {' '}
        <SparxLogo height="16px" />
      </div>
    </div>
  )
}

export default ConfigurationInvalidSplash
